import { isValidEmail } from "@/utils/validators/isValidEmail";
import { isValidPassword } from "@/utils/validators/isValidPassword";

export const signInFormValues = {
  email: "",
  password: "",
};

export function signInFormValidator(value: typeof signInFormValues) {
  return {
    email: !isValidEmail(value.email) && "Email inválido",
    password:
      !isValidPassword(value.password) &&
      "A senha deve ter mais de 8 caracteres, 1 letra maiuscula, 1 letra minuscula, 1 numero e 1 caractere especial (@ $ ! # % * ? & -)",
  };
}
